import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContainerHeader = styled.div`
  text-align: center;
  padding: 10px;
`;

export const HeaderTitle = styled.div`
`;

export const ContainerBody = styled.div`
  flex: 1;
  max-height: 70vh;
  overflow-y: auto;
  padding: 0px 150px;
`;

export const ContainerFooter = styled.div`
  padding-top: 5px;
  border-top: 1px solid #ddd;
`;